import { IconWithTextStoryblok } from "@/types/component-types-sb";
import {
  ImagesSquareIcon,
  ShieldCheckIcon,
  TrophyIcon,
  UsersThreeIcon,
} from "@phosphor-icons/react";
import styles from "./icon-with-text.module.scss";

interface Props {
  blok: IconWithTextStoryblok;
}

export default function IconWithText(props: Props) {
  const iconName = props.blok.icon;
  const icon =
    iconName === "media-library" ? (
      <ImagesSquareIcon size={24} aria-hidden="true" />
    ) : iconName === "trophy" ? (
      <TrophyIcon size={24} aria-hidden="true" />
    ) : iconName === "people" ? (
      <UsersThreeIcon size={24} aria-hidden="true" />
    ) : (
      <ShieldCheckIcon size={24} aria-hidden="true" />
    );

  return (
    <div className={styles.itemWrapper}>
      <div className={styles.iconWrapper}>{icon}</div>
      <div className={styles.textWrapper}>{props.blok.text}</div>
    </div>
  );
}
